import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { Column } from '@app/modules/table/classes/column.class';

export class AssignedOnColumn extends Column {
    title = 'table.assets.dateAssignedColumn';
    property = 'assignedOn';
    sortable = false;
    type: CellDisplay = CellDisplay.date;
}
